<template>
    <div class="professional-modal">
        <transition name="modal">
            <div class="modal-mask">
                <div
                    class="modal-dialog"
                    role="document"
                >
                    <div class="modal-content">
                        <b-alert
                            show
                            variant="success"
                            class="mb-0"
                        >
                            <button
                                class="close"
                                @click="$emit('close')"
                            >
                                <i class="fa fa-close"></i>
                            </button>
                            <h4
                                class="alert-heading"
                                style="padding-top: 15px"
                            >
                                商品をカートへ追加いたしました
                            </h4>
                            <p class="mb-0">
                                <a
                                    href="/cart"
                                    class="btn btn-accent"
                                    >レンタルする</a
                                >
                            </p>
                        </b-alert>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'professional-add-cart-modal',
}
</script>

<style lang="scss" scoped>
.modal-content {
    height: auto;
}
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-header {
    display: flex;
}
.modal-header h2 {
    margin-bottom: 0;
}
.modal-header button {
    position: absolute;
    right: 20px;
    top: 0;
    border: 0;
    font-size: 20px;
    background-color: #fff;
}

.modal-body {
    margin: 0;
    padding: 0px;
    max-height: 70vh;
}

.modal-default-button {
    float: right;
}

.alert-heading {
    font-size: 19px;
    margin-bottom: 50px !important;
}

.close {
    position: absolute;
    right: 25px;
    top: 8px;
    font-size: 20px;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.alert {
    margin-bottom: 0px;
}

@media all and (-ms-high-contrast: none) {
    .modal-mask {
        width: 100%;
    }
    .modal-dialog {
        position: absolute;
        top: 30%;
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/professionalDesign/ProfessionalAddCartModal.vue